<template>
  <Breadcrumbs
      title="Promotions"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Promotions', path: '/promotions' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <promotionsList />
    </div>
  </div>
</template>

<script>
import promotionsList from './promotions_list.vue'
export default {
  name: 'indexList',
  components: {
    promotionsList,
  },
}
</script>